export const fontFilePaths: string[] = [
  "/fonts/Zeyada_Regular.json",
  "/fonts/Ga Maamli_Regular.json",
  "/fonts/Cinzel_Regular.json",
  "/fonts/Orbitron_Regular.json",
  "/fonts/Faustina Light_Regular.json",
  "/fonts/Roboto Mono_Italic.json",
  "/fonts/Roboto Mono_Regular.json",
  "/fonts/Bodoni Moda SC_Italic.json",
  "/fonts/Grey Qo_Regular'.json",
  "/fonts/Bebas Neue_Regular.json",
  "/fonts/Syne_Regular.json",
  "/fonts/Jacquard 12_Regular.json",
  "/fonts/helvetiker_regular.typeface.json",
  "/fonts/Faustina Light_Italic.json",
  "/fonts/Sankofa Display_Regular.json",
  "/fonts/Great Vibes_Regular.json",
  "/fonts/Silkscreen_Regular.json",
  "/fonts/Bodoni Moda SC_Regular.json",
  "/fonts/Silkscreen_Bold.json",
];
